// Simple SVG flags (clean, no system emojis)
const FlagES = (p) => (
  <svg viewBox="0 0 3 2" {...p}><rect width="3" height="2" fill="#C60B1E"/><rect y="0.5" width="3" height="1" fill="#FFC400"/></svg>
);
const FlagPT = (p) => (
  <svg viewBox="0 0 6 4" {...p}><rect width="6" height="4" fill="#FF0000"/><rect width="2.4" height="4" fill="#046A38"/><circle cx="2.4" cy="2" r="0.7" fill="#FFD700"/></svg>
);
const FlagEN = (p) => (
  <svg viewBox="0 0 60 30" {...p}>
    <clipPath id="t"><path d="M0,0 v30 h60 v-30 z"/></clipPath>
    <clipPath id="s"><path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z"/></clipPath>
    <g clipPath="url(#t)">
      <path d="M0,0 v30 h60 v-30 z" fill="#012169"/>
      <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6"/>
      <path d="M0,0 L60,30 M60,0 L0,30" clipPath="url(#s)" stroke="#C8102E" strokeWidth="4"/>
      <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10"/>
      <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6"/>
    </g>
  </svg>
);
const FlagDE = (p) => (
  <svg viewBox="0 0 5 3" {...p}><rect width="5" height="1" y="0" fill="#000"/><rect width="5" height="1" y="1" fill="#DD0000"/><rect width="5" height="1" y="2" fill="#FFCE00"/></svg>
);
const FlagFR = (p) => (
  <svg viewBox="0 0 3 2" {...p}><rect width="1" height="2" fill="#002654"/><rect x="1" width="1" height="2" fill="#fff"/><rect x="2" width="1" height="2" fill="#ED2939"/></svg>
);

export const LANGS = [
  { code: "es", label: "Español",   short: "ES", Flag: FlagES },
  { code: "pt", label: "Português", short: "PT", Flag: FlagPT },
  { code: "en", label: "English",   short: "EN", Flag: FlagEN },
  { code: "de", label: "Deutsch",   short: "DE", Flag: FlagDE },
  { code: "fr", label: "Français",  short: "FR", Flag: FlagFR },
];

export const getLang = (code) => LANGS.find((l) => l.code === code) || LANGS[0];
